<div class="relative w-full aspect-video bg-cover bg-center bg-[var(--background_secondary)]"
    [class.cursor-pointer]="showPlay()"
    [transcodeImage]="vm().poster"
    data-testid="details_hero"
    (click)="showPlay() ? play.emit() : null">

    <!-- Trailer preview: the shared player view is relocated into this anchor while the modal is open. -->
    <div class="absolute inset-0 overflow-hidden transition-opacity"
        [class.opacity-0]="!previewVideoPlaying()" [class.pointer-events-none]="!previewVideoPlaying()">
        <ng-container #playerContainer></ng-container>
    </div>

    @if (restricted()) {
        <content-rating-lock />
    }

    <div class="absolute inset-x-0 bottom-0 h-2/5 bg-[linear-gradient(to_top,var(--background_primary),transparent)]"></div>

    @if (previewVideoPlaying()) {
        <rounded-icon-button class="!absolute bottom-4 right-4 z-10"
            (onClick)="toggleMute()" (click)="$event.stopPropagation()"
            [imgSrc]="skinning.getImage(previewVideoMuted() ? 'icon_sound_off' : 'icon_sound_on')"></rounded-icon-button>
    }
</div>

<div class="px-8 mt-5">
    <div class="flex items-center mb-3">
        @if (channelIcon(); as icon) {
            <img [transcodeImage]="icon" class="h-7 w-auto mr-3" transcodeAxis="height" alt="" data-testid="details_channel" />
        }
        @if (vm().badge || vm().availabilityStartTime || vm().availabilityEndTime) {
            <badge [badge]="vm().badge" [variant]="BadgeVariant.ItemDetails"
                [availabilityStartTime]="vm().availabilityStartTime"
                [availabilityEndTime]="vm().availabilityEndTime"
                [hasUpcomingEnabled]="vm().hasUpcomingEnabled"
                [hasOutgoingEnabled]="vm().hasOutgoingEnabled"
                [showAutomaticBadge]="true"></badge>
        }
    </div>

    <h1 class="text-3xl font-bold mb-2" data-testid="details_title">{{ restricted() ? ('common.protected_content_title' | transloco) : vm().headerTitle }}</h1>

    <div class="flex flex-wrap items-center gap-x-4 gap-y-1 mb-5 opacity-85">
        @if (vm().dateLabel) {
            <span class="flex items-center"><img class="h-4 w-auto mr-2" [src]="skinning.getImage('icon_date')">{{ vm().dateLabel }}</span>
        }
        @if (vm().timeRangeLabel) {
            <span class="flex items-center" data-testid="details_epg-time"><img class="h-4 w-auto mr-2" [src]="skinning.getImage('icon_time')">{{ vm().timeRangeLabel }}</span>
        }
        @if (vm().durationLabel) {
            <span class="flex items-center"><img class="h-4 w-auto mr-2" [src]="skinning.getImage('icon_duration')">{{ vm().durationLabel }}</span>
        }
        @if (vm().contentRating) {
            <span class="flex items-center"><img class="h-4 w-auto mr-2" [src]="skinning.getImage('icon_pg')">{{ vm().contentRating }}</span>
        }
        @if (vm().productionYear) {
            <span>{{ vm().productionYear }}</span>
        }
        @if (vm().category) {
            <span data-testid="details_category">{{ vm().category }}</span>
        }
    </div>
</div>
